export const ORTHOGRAPHY = [
  'q',
  'w',
  'e',
  'r',
  't',
  'z',
  'u',
  'i',
  'o',
  'p',
  'š',
  'đ',
  'a',
  's',
  'd',
  'f',
  'g',
  'h',
  'j',
  'k',
  'l',
  'č',
  'ć',
  'ž',
  'y',
  'x',
  'c',
  'v',
  'b',
  'n',
  'm',
]
